<template>
    <multiselect
            :options="projectContactsByProjectId(projectId)"
            v-model="subscribedContacts"
            :close-on-select="false"
            :clear-on-select="true"
            :preserve-search="true"
            :multiple="true"
            placeholder="Subscribed Contacts to notify"
            label="full_name"
            track-by="id"
            @input="$emit('submitting', true)"
    ></multiselect>
</template>

<script>
    import SubscribedContacts from '../mixins/SubscribedContacts'

    export default {
        mixins: [SubscribedContacts],

        watch: {
            subscribedContacts: {
                deep: true,
                handler() {
                    if (!this.dataLoaded) return

                    this.$emit('input', this.subscribedContacts)
                }
            }
        },

        mounted() {
            if (this.referenceType === 'project') {
                this.projectId = this.$route.params.slug
            } else {
                this.projectId = this.taskById(this.$route.params.slug).project_id
            }

            this.fetchContacts({project_id: this.projectId}).then(() => {
                let ids = this.currentSubscribedContactsIds

                this.subscribedContacts = _.filter(this.contacts, contact =>
                    ids.includes(contact.id)
                )

                this.$emit('input', this.subscribedContacts)

                this.$nextTick(() => {
                    this.dataLoaded = true
                })
            })
        }
    }
</script>
